import { Routes } from '@angular/router';
import { TimeEntriesCalendarViewComponent } from '../../../pages/time-tracking/time-entries-calendar-view/time-entries-calendar-view.component';
import { TimeEntriesListViewComponent } from '../../../pages/time-tracking/time-entries-list-view/time-entries-list-view.component';
import { ShiveRoutes } from '../segments/route-segments';

export const TimeTrackingRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.Calendar,
  },
  {
    path: ShiveRoutes.Calendar,
    component: TimeEntriesCalendarViewComponent,
  },
  {
    path: ShiveRoutes.List,
    component: TimeEntriesListViewComponent,
  },
];
